module.exports = __webpack_public_path__ + "img/Réalisation portillon de jardin.3cd993c5.jpg";